/// Full default search input for a bare `/insights` link or redirect
/// target: every `.catch()`-only field `insightsSearchSchema`
/// (`features/insights/routes/insights.route.search.ts`) declares (`tab`
/// excluded, every caller overrides it) at its schema default (30-day
/// window, no department filter, dimension metric, People Ops brief lens).
///
/// Lives in `shared/` rather than the insights feature: A6 is a one-way
/// street (features never import each other), and callers across several
/// OTHER features build these literal search objects too (Home's alert and
/// KPI-tile links, pulse-dashboards' comparison/theme links, pulse-actions'
/// "source insight" link, the sidebar's Insights nav item). None of those
/// features can import from `features/insights`, so this constant lives
/// where every one of them (and insights.route.search.test.ts, which
/// verifies it stays in sync with the schema's own catch defaults) can
/// reach it without crossing that boundary.
export const INSIGHTS_SEARCH_DEFAULTS = {
  window: "30d",
  depts: "",
  metric: "dimension",
  briefAudience: "people_ops",
} as const;
